import InlineAskAssistantButton from './InlineAskAssistantButton.vue';

export default InlineAskAssistantButton;
